// Static Venezuela political division (state -> municipalities) + helpers.
import data from "@/lib/venezuela.json";

export const VENEZUELA = data;
export const ESTADOS = Object.keys(data).sort((a, b) => a.localeCompare(b, "es"));

export const municipiosOf = (estado) => (estado && data[estado] ? data[estado] : []);

const normalize = (s) =>
  (s || "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

// Best-effort mapping from a browser reverse-geocode result to our standardized
// state + municipality. Returns { state, municipality } (either may be "").
export function resolveGeocode(stateRaw, muniRaw) {
  const ns = normalize(stateRaw);
  const nm = normalize(muniRaw);

  // Distrito Capital / Caracas special-casing.
  if (ns.includes("capital") || ns.includes("caracas") || nm.includes("caracas") || nm.includes("libertador")) {
    if (!ns.includes("vargas") && !ns.includes("guaira")) {
      return { state: "Distrito Capital", municipality: "Libertador" };
    }
  }

  let matchedState = "";
  for (const estado of ESTADOS) {
    const ne = normalize(estado);
    if (ne === ns || (ns && (ns.includes(ne) || ne.includes(ns)))) { matchedState = estado; break; }
  }

  let matchedMuni = "";
  if (matchedState) {
    for (const muni of municipiosOf(matchedState)) {
      const nmu = normalize(muni);
      if (nmu === nm || (nm && (nm.includes(nmu) || nmu.includes(nm)))) { matchedMuni = muni; break; }
    }
  }

  return { state: matchedState, municipality: matchedMuni };
}
